module.exports = __webpack_public_path__ + "static/media/closest-1.a65f3eda.mp3";